"use client";

import { useEffect } from "react";
import { create } from "zustand";

export const useGeneralContext = create<Store>((set, get) => ({
  state: "initial" satisfies State,
  brandAssets: {
    logoUrl: null,
    colors: {
      background: "hsl(0, 0%, 0%)",
      foreground: "hsl(0, 0%, 100%)",
    },
  },
  setBrandAssets(brandAssets: BrandAssets) {
    console.log({ brandAssets });
    set((current) => ({
      ...current,
      brandAssets,
    }));
  },
  showOutro: () => {
    const { state } = get();
    return state === "complete" || state === "uploading";
  },
  setState(state) {
    const currentState = get().state;
    console.log(
      `[GeneralContext] State transition: ${currentState} → ${state}`,
    );
    set((current) => ({
      ...current,
      state: state,
    }));
  },
  getState: () => {
    return get().state;
  },
}));

export const SetBrandAssets = (props: { brandAssets: BrandAssets }) => {
  const { setBrandAssets } = useGeneralContext();

  useEffect(() => {
    setBrandAssets(props.brandAssets);
  }, []);

  return null;
};

/**
 * State documentation
 * @typedef {string} State
 * @description Represents the current state of the interview process
 * @enum {string}
 * @property {"initial"} initial - Initial state nothing has happened just rendering the first state
 * @property {"ready"} ready - Interviewee has enabled microphone and camera and is ready to start the interview
 * @property {"active"} active - Interview has started
 * @property {"uploading"} uploading - Interview has ended but we are waiting for it to finish post-processing
 * @property {"complete"} complete - Interview is finished and all assets have been uploaded
 */
type State = "initial" | "ready" | "active" | "uploading" | "complete";

export type BrandAssets = {
  logoUrl: string | null;
  colors: {
    background: string;
    foreground: string;
  };
};

type Store = {
  state: State;
  brandAssets: BrandAssets;
  setBrandAssets: (brandAssets: BrandAssets) => void;
  showOutro: () => boolean;
  setState: (state: State) => void;
  getState: () => State;
};
